import * as React from 'react'
import * as DrupalModel from '../../../api/drupal/drupalTypes'
import { getCookie } from '../../../utils/cookies'
import { PREF_BRANCH_COOKIE, confirmLocation } from './BranchLocalizationUtils'
import { features } from '../../../features'

export type LocalizationProps = {
  readonly selectedLocationId: string
  readonly branchLocations: DrupalModel.Location[]
  readonly selectLocation: (selectedId: string) => void
}

export const BranchLocalizationLayout = (props: LocalizationProps) => {
  if (features().branchLocalization == 'off') return <></>

  const { branchLocations } = props
  const preferredBranchId = getCookie(PREF_BRANCH_COOKIE)

  React.useEffect(() => {
    const select = document.getElementById('lh-location') as HTMLSelectElement
    const helperSpan = document.getElementById('helper-span')
    helperSpan.textContent = select.selectedOptions[0].text
    helperSpan.style.font = window.getComputedStyle(select).font
    const textWidth = helperSpan.offsetWidth
    select.style.width = textWidth + 24 + 'px'
  }, [])

  return (
    <div className="lh__dropdown">
      <div className="lh__container container--full gutter--m align--center">
        <div className="lh__formwrap">
          <label className="lh__formlabel" htmlFor="lh-location">
            Bibliotheek:
          </label>
          <div className="lh__forminput">
            <select
              className="lh__select"
              id="lh-location"
              value={preferredBranchId}
              onChange={e => confirmLocation(e.target.value, branchLocations)}
            >
              <option value="">{preferredBranchId ? 'Geen voorkeur' : 'Selecteer jouw bibliotheek'}</option>
              {branchLocations.map(loc => {
                return (
                  <option key={loc.id} value={loc.id}>
                    {loc.title}
                  </option>
                )
              })}
            </select>
            <span id="helper-span" style={{ position: 'absolute', visibility: 'hidden', whiteSpace: 'nowrap' }}></span>
            <svg
              className="lh__icon"
              aria-hidden="true"
              fill="none"
              height="10"
              viewBox="0 0 14 10"
              width="14"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                clipRule="evenodd"
                d="m.324282.989902c.407119-.373192 1.039688-.345689 1.412878.061428l5.26285 5.74129 5.26289-5.74129c.3731-.407117 1.0057-.43462 1.4128-.061428.4071.373188.4347 1.005758.0615 1.412878l-6.00004 6.54546c-.18941.20663-.45685.32428-.73715.32428-.28031 0-.54775-.11765-.73716-.32428l-5.999999-6.54546c-.373192-.40712-.3456886-1.03969.061431-1.412878z"
                fill="#090b09"
                fillRule="evenodd"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  )
}
